import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  maintenance: {
    id: 'core.systemNotification.maintenance',
    defaultMessage:
      'Maintenance is scheduled for the period from {startTs} to {finishTs}.',
  },
  upgrade: {
    id: 'core.systemNotification.upgrade',
    defaultMessage:
      'Upgrade is scheduled fore the period from {startTs} to {finishTs}',
  },
});
